export default "__VITE_ASSET__ZQPChyCm__"